__turbopack_context__.v({
  "regionLink": "McWp5G_regionLink",
  "regionsGrid": "McWp5G_regionsGrid",
});
